import { Button, Card, TextButton, Typography, useOverlayContext } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from "../../contexts";
import { useOnMount } from "../../hooks/useOnMount";
import { ServerError } from "../../infra/ErrorResponse";
import { handleRequest } from "../../infra/utils";
import { selectors } from "../../store/state-selectors";
import { useStore, useStoreActions } from "../../store/store-context";
import styles from "./AcceptInvitationPage.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const deprecatedTestIds = {
  AcceptInvitationPageTestIds: {
    Logo: 'logo',
    InvitationTitle: 'invitation-title',
    InvitationDescription: 'invitation-description',
    InvitationEmail: 'invitation-email',
    InvitationCard: 'invitation-card',
    InvitationBusinessName: businessName => "invitation-business-name-".concat(businessName),
    InvitationAcceptButton: inviteId => "invitation-accept-button-".concat(inviteId),
    InvitationStartNewBusinessLink: 'invitation-start-new-business-link',
    InvitationStartNewBusinessLinkButton: 'invitation-start-new-business-link-button',
    ErrorToast: 'failed-to-accept-invitation-error-toast'
  }
};
const AcceptInvitationPage = _ref => {
  let {
    setShowInvitationPage
  } = _ref;
  const {
    AcceptInvitationPageTestIds
  } = useTestIds({
    deprecatedTestIds
  });
  const userEmail = useStore(selectors.user.email);
  const teamInvites = useStore(selectors.teamInvites);
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    locationReload
  } = useIoContext();
  const {
    showErrorToast
  } = useOverlayContext();
  const handleAcceptInvitation = async _ref2 => {
    let {
      invitationId,
      businessId
    } = _ref2;
    const response = await handleRequest(api.business.acceptTeamInvite({
      invitationId,
      businessId
    }));
    if (response.success) {
      var _teamInvites$find;
      setShowInvitationPage(false);
      logBI(19101, {
        invitingBusinessName: (_teamInvites$find = teamInvites.find(invite => invite.inviteId() === invitationId)) === null || _teamInvites$find === void 0 ? void 0 : _teamInvites$find.businessName(),
        invitingBusinessId: businessId
      });
      locationReload();
    } else {
      const errorText = response.error.hasServerError(ServerError.InvalidTeamInvitation) ? response.error.invalidTeamInvitationErrorText() : 'Failed to accept invitation';
      showErrorToast(errorText, AcceptInvitationPageTestIds.ErrorToast());
    }
  };
  const handleStartNewBusiness = () => {
    setShowInvitationPage(false);
  };
  useOnMount(() => {
    logBI(19100);
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.acceptInvitationPageContainer,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.logoContainer,
      "data-testid": AcceptInvitationPageTestIds.Logo(),
      children: /*#__PURE__*/_jsx(AnchorLogo, {
        theme: "dark",
        height: 56
      })
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      "data-testid": AcceptInvitationPageTestIds.InvitationTitle(),
      children: "You\u2019ve been invited to join your team on Anchor"
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph1",
      skin: "secondary",
      "data-testid": AcceptInvitationPageTestIds.InvitationDescription(),
      children: ["We found pending invitations for", ' ', /*#__PURE__*/_jsx(Typography, {
        weight: "normal",
        skin: "secondary",
        as: "span",
        "data-testid": AcceptInvitationPageTestIds.InvitationEmail(),
        children: userEmail
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.invitationsContainer,
      children: teamInvites.map(teamInvite => /*#__PURE__*/_jsxs(Card, {
        className: styles.invitationContainer,
        "data-testid": AcceptInvitationPageTestIds.InvitationCard(),
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          ellipsis: true,
          "data-testid": AcceptInvitationPageTestIds.InvitationBusinessName(teamInvite.businessName()),
          children: teamInvite.businessName()
        }), /*#__PURE__*/_jsx(Button, {
          size: "small",
          "data-testid": AcceptInvitationPageTestIds.InvitationAcceptButton(teamInvite.inviteId()),
          onClick: () => handleAcceptInvitation({
            invitationId: teamInvite.inviteId(),
            businessId: teamInvite.businessId()
          }),
          children: "Accept invitation"
        })]
      }, teamInvite.businessName()))
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph1",
      skin: "secondary",
      "data-testid": AcceptInvitationPageTestIds.InvitationStartNewBusinessLink(),
      children: ["Looking to start a new business instead?", ' ', /*#__PURE__*/_jsx(TextButton, {
        onClick: handleStartNewBusiness,
        "data-testid": AcceptInvitationPageTestIds.InvitationStartNewBusinessLinkButton(),
        children: "Click here"
      })]
    })]
  });
};
export default AcceptInvitationPage;